import React, {useEffect, useCallback, useContext} from 'react'
import qrCode from '../../assets/images/qrcode.png'
import barcodeImg from '../../assets/images/barcode.png'
import barcodeText from '../../assets/images/barcode_text.png'
import aplogo from '../../assets/images/logo.png'

import useStyles from './BarcodeLabelItem.styles'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'
import BarcodeLabelEditableText from './BarcodeLabelEditableText'
import BarcodeLabelFileUploader from './BarcodeLabelFileUploader'
import BarcodeLabelCompanyLogo from './BarcodeLabelCompanyLogo'
import BarcodeLabelFieldSelect from './BarcodeLabelFieldSelect'
import BarcodeRRD from './BarcodeRRD'

function BarcodeLabelItem(props) {
  const classes = useStyles()
  const {selectItem} = useContext(BarcodeLabelEditorContext)
  const dndItem = props.item
  const [dndItem2, setdndItem] = React.useState({
    ...props.item,
  })

  useEffect(() => {
    setdndItem({...dndItem})
  }, [dndItem])

  const updateItem = useCallback(
    item => {
      props.updateDndItem({...item, focused: props.focused}, props.index)
    },
    [props]
  )

  function handleChange(updatedItem) {
    setdndItem(updatedItem)
    updateItem(updatedItem)
  }

  const handleClickDelete = e => {
    e.preventDefault()
    props.removeDndItem(props.item, props.index)
  }

  function getItemDesign() {
    switch (props.item.key.split('_')[0]) {
      case 'qrcode':
        return <div className={classes.image} style={{backgroundImage: `url(${qrCode})`}}></div>

      case 'barcodenotext':
        return <div className={classes.image} style={{backgroundImage: `url(${barcodeImg})`}}></div>

      case 'barcode':
        return (
          <div className={classes.image} style={{backgroundImage: `url(${barcodeText})`}}></div>
        )

      case 'textbox':
        return <BarcodeLabelEditableText item={dndItem} onChange={handleChange} />

      case 'image':
        return <BarcodeLabelFileUploader item={dndItem} onChange={handleChange} />

      case 'aplogo':
        return <div className={classes.image} style={{backgroundImage: `url(${aplogo})`}}></div>

      case 'companylogo':
        return <BarcodeLabelCompanyLogo className={classes.image} item={dndItem} />

      case 'fieldselect':
        return <BarcodeLabelFieldSelect item={dndItem} onChange={handleChange} />

      default:
        return
    }
  }

  const handleRotateEnd = angle => {
    let item = dndItem
    item.position.angle = angle.degrees
    setdndItem({...item})
  }

  const handleResizeEnd = ({offsetX, offsetY, width, height}) => {
    let item = dndItem
    item.position.left += offsetX
    item.position.top += offsetY
    item.size.width = width
    item.size.height = height
    setdndItem({...item})
  }
  const handleMoveEnd = ({x, y}) => {
    let item = dndItem
    item.position.left += x
    item.position.top += y
    setdndItem({...item})
  }

  return (
    <BarcodeRRD
      lockAspectRatio={!!dndItem2.size.lock_ratio}
      onRotateEnd={handleRotateEnd}
      onResizeEnd={handleResizeEnd}
      onMoveEnd={handleMoveEnd}
      onClickDelete={handleClickDelete}
      width={dndItem.size.width}
      height={dndItem.size.height}
      x={dndItem.position.left}
      y={dndItem.position.top}
      angleDeg={dndItem.position.angle}
      edit={props.focused}
      onClick={() => {
        selectItem({index: props.index})
      }}
    >
      {getItemDesign()}
    </BarcodeRRD>
  )
}

export default BarcodeLabelItem
